// extracted by mini-css-extract-plugin
export default {"label":"InputTableLabel_label__A9HqQ"};